var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBakerySolid = function SvgBakerySolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25a5.728 5.728 0 0 0-3.55 1.226 4.75 4.75 0 0 0-4.63 8.054l1.055 7.026a3.75 3.75 0 0 0 3.709 3.194h6.832a3.75 3.75 0 0 0 3.709-3.194l1.054-7.027a4.75 4.75 0 0 0-4.63-8.054A5.728 5.728 0 0 0 12 2.25Zm-2.75 18h1.5V15a.75.75 0 0 0-1.5 0v5.25Zm4 0h1.5V15a.75.75 0 0 0-1.5 0v5.25Zm7-12.25c0 .873-.344 1.665-.905 2.25H4.655A3.25 3.25 0 0 1 8.3 5.02l.45.197.36-.334A4.232 4.232 0 0 1 12 3.75c1.116 0 2.13.43 2.89 1.133l.36.334.45-.197A3.25 3.25 0 0 1 20.25 8Z",
    fill: "currentColor"
  })));
};
export default SvgBakerySolid;